import { render, staticRenderFns } from "./MobileLogin.vue?vue&type=template&id=70a07964&scoped=true&"
import script from "./MobileLogin.vue?vue&type=script&lang=ts&"
export * from "./MobileLogin.vue?vue&type=script&lang=ts&"
import style0 from "./MobileLogin.vue?vue&type=style&index=0&id=70a07964&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a07964",
  null
  
)

export default component.exports